import './analytics_module.scss'
import './__content.coffee'
